/**
 * Default number of hotels to display per search page
 */
export const ITEMS_PER_PAGE: number = 25;

/**
 * Default max page value until we don't know the total count of items
 */
export const DEFAULT_MAX_PAGE: number = 10;
